import * as T from '../../constants/boost';

// Send / history
export const sendBoostMessage = (data) => ({
  type: T.SEND_BOOST_MESSAGE,
  data,
});
export const sendBoostBulk = (data) => ({ type: T.SEND_BOOST_BULK, data });
// Pre-send estimate: total recipients / segments / unicode count / cost for
// the composed message across the resolved audience (real names substituted).
export const fetchBoostCostEstimate = (data) => ({
  type: T.FETCH_BOOST_COST_ESTIMATE,
  data,
});
export const storeBoostCostEstimate = (estimate) => ({
  type: T.STORE_BOOST_COST_ESTIMATE,
  estimate,
});
export const storeBoostEstimating = (estimating) => ({
  type: T.STORE_BOOST_ESTIMATING,
  estimating,
});
export const clearBoostCostEstimate = () => ({
  type: T.CLEAR_BOOST_COST_ESTIMATE,
});
// Spec §15 "Retry Failed" — re-dispatches the SAME message's failed
// recipients (no duplicate history entry).
export const retryBoostMessage = (data) => ({
  type: T.RETRY_BOOST_MESSAGE,
  data,
});
// Per-recipient retry — re-dispatches a SINGLE failed recipient of a
// message (the "Retry" button on a failed row in the Delivery Report).
export const retryBoostRecipient = (data) => ({
  type: T.RETRY_BOOST_RECIPIENT,
  data,
});
export const cancelBoostMessage = (data) => ({
  type: T.CANCEL_BOOST_MESSAGE,
  data,
});
export const fetchBoostHistory = (data) => ({
  type: T.FETCH_BOOST_HISTORY,
  data,
});
export const storeBoostHistory = (messages) => ({
  type: T.STORE_BOOST_HISTORY,
  messages,
});
export const fetchBoostDetail = (data) => ({
  type: T.FETCH_BOOST_DETAIL,
  data,
});
export const storeBoostDetail = (detail) => ({
  type: T.STORE_BOOST_DETAIL,
  detail,
});
export const storeBoostSending = (sending) => ({
  type: T.STORE_BOOST_SENDING,
  sending,
});
// Outcome of the last send/sendBulk call — { ok, message, ts } or null
// while a send is in flight. The composer navigates to the success
// screen ONLY when ok is true (no more optimistic "Sent!" on errors).
export const storeBoostSendResult = (result) => ({
  type: T.STORE_BOOST_SEND_RESULT,
  result,
});
export const clearBoostDetail = () => ({ type: T.CLEAR_BOOST_DETAIL });

// Audience / customers
export const fetchBoostCustomers = (data) => ({
  type: T.FETCH_BOOST_CUSTOMERS,
  data,
});
export const storeBoostCustomers = (customers) => ({
  type: T.STORE_BOOST_CUSTOMERS,
  customers,
});

// Templates
export const fetchBoostTemplates = (data) => ({
  type: T.FETCH_BOOST_TEMPLATES,
  data,
});
export const saveBoostTemplate = (data) => ({
  type: T.SAVE_BOOST_TEMPLATE,
  data,
});
export const deleteBoostTemplate = (data) => ({
  type: T.DELETE_BOOST_TEMPLATE,
  data,
});
export const storeBoostTemplates = (templates) => ({
  type: T.STORE_BOOST_TEMPLATES,
  templates,
});

// Credit
export const fetchBoostCredit = (data) => ({
  type: T.FETCH_BOOST_CREDIT,
  data,
});
export const rechargeBoostCredit = (data) => ({
  type: T.RECHARGE_BOOST_CREDIT,
  data,
});
export const storeBoostCredit = (credit) => ({
  type: T.STORE_BOOST_CREDIT,
  credit,
});

// Settings
export const fetchBoostSettings = (data) => ({
  type: T.FETCH_BOOST_SETTINGS,
  data,
});
export const saveBoostSettings = (data) => ({
  type: T.SAVE_BOOST_SETTINGS,
  data,
});
export const storeBoostSettings = (settings) => ({
  type: T.STORE_BOOST_SETTINGS,
  settings,
});

// Admin
export const fetchBoostAdmin = (data) => ({ type: T.FETCH_BOOST_ADMIN, data });
export const saveBoostAdmin = (data) => ({ type: T.SAVE_BOOST_ADMIN, data });
export const resetBoostBalance = (data) => ({
  type: T.RESET_BOOST_BALANCE,
  data,
});
export const pauseBoost = (data) => ({ type: T.PAUSE_BOOST, data });
export const storeBoostAdmin = (admin) => ({
  type: T.STORE_BOOST_ADMIN,
  admin,
});

// Analytics
export const fetchBoostAnalytics = (data) => ({
  type: T.FETCH_BOOST_ANALYTICS,
  data,
});
export const storeBoostAnalytics = (analytics) => ({
  type: T.STORE_BOOST_ANALYTICS,
  analytics,
});

// Platform config (rates, chips, defaults — ROLE_OWNER edits)
export const fetchBoostPlatformConfig = () => ({
  type: T.FETCH_BOOST_PLATFORM_CONFIG,
});
export const saveBoostPlatformConfig = (data) => ({
  type: T.SAVE_BOOST_PLATFORM_CONFIG,
  data,
});
export const storeBoostPlatformConfig = (platformConfig) => ({
  type: T.STORE_BOOST_PLATFORM_CONFIG,
  platformConfig,
});
